import { useState } from 'react'
import { TrackActionProvider } from '@opallabs/analytics'
import { SimpleWorkspace } from '@opallabs/concepts'
import { DefaultQueryClientProvider } from '@opallabs/higgs'
import { WorkspaceContext, ThemeProvider } from '@opallabs/hooks'
import { ToastComponent, WithTheme } from '@opallabs/lapidary'
import { AddMomentToBoardModal } from '..'
import { AddToBoardSuccessToast } from '../AddToBoardToasts'
import { AddMomentToBoardModalProps, AddToBoardToastProps } from '../types'
import { QueryableAddToBoardModalProvider } from './QueryableAddMomentToBoardContext'

type QueryableAddMomentToBoardModalProps = Readonly<
  Omit<AddMomentToBoardModalProps, 'isVisible' | 'onAddToBoard'> &
    WithTheme & { momentUuid: string; workspace: SimpleWorkspace }
>

export const QueryableAddToBoardToast: ToastComponent<AddToBoardToastProps> = (
  props
) => {
  return (
    <DefaultQueryClientProvider>
      <TrackActionProvider>
        <AddToBoardSuccessToast {...props} />
      </TrackActionProvider>
    </DefaultQueryClientProvider>
  )
}

export const QueryableAddMomentToBoardModal: React.FC<
  QueryableAddMomentToBoardModalProps
> = ({
  limitOptions,
  momentUuid,
  onCloseModal,
  theme = 'light',
  unscheduleByDefault = false,
  workspace,
}) => {
  const [isVisible, setIsVisible] = useState(true)

  return (
    <DefaultQueryClientProvider>
      <ThemeProvider theme={theme}>
        <TrackActionProvider>
          <WorkspaceContext.Provider value={workspace}>
            <QueryableAddToBoardModalProvider>
              <AddMomentToBoardModal
                isVisible={isVisible}
                limitOptions={limitOptions}
                momentUuids={[momentUuid]}
                // supplied by context so it can be defined within QueryClientProvider
                onAddToBoard={() => null}
                onCloseModal={(changes) => {
                  setIsVisible(false)
                  onCloseModal(changes)
                }}
                unscheduleByDefault={unscheduleByDefault}
              />
            </QueryableAddToBoardModalProvider>
          </WorkspaceContext.Provider>
        </TrackActionProvider>
      </ThemeProvider>
    </DefaultQueryClientProvider>
  )
}
